import { useSyncExternalStore } from "react";
import { useOnlineStatusStore } from "../platform/PlatformContext";

/**
 * Returns whether the device reports network connectivity (browser events in the PWA, the
 * `Network` plugin in the native apps, T-082). `true` does not guarantee that the server is
 * reachable; the synchronization status tells that. Every component reads the one state of the
 * platform provider, which starts with `navigator.onLine` (F-78), so a page opened offline never
 * shows „online“ first and two components never disagree.
 *
 * @returns `true` if online.
 */
export function useOnlineStatus(): boolean {
  const store = useOnlineStatusStore();
  const online = useSyncExternalStore(store.subscribe, store.getSnapshot, store.getSnapshot);

  return online;
}
